import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOHead from "../../components/feature/SEOHead";
import DemoHero from "./components/DemoHero";
import DemoSteps from "./components/DemoSteps";
import DemoUseCases from "./components/DemoUseCases";

const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://trackly.app";

const demoJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "See Trackly in Action — Live Demo & Walkthroughs | Profit Tracker",
  "description": "Watch how Trackly calculates real net profit and ROI on every flip. Step-by-step demo for sports card flippers, sneaker resellers, and more.",
  "url": `${SITE_URL}/demonstration`,
  "isPartOf": {
    "@type": "WebSite",
    "name": "Trackly",
    "url": SITE_URL,
  },
};

export default function Demonstration() {
  return (
    <div className="bg-[#050505] min-h-screen">
      <SEOHead
        title="See Trackly in Action — Live Demo & Walkthroughs | Profit Tracker"
        description="Watch how Trackly calculates real net profit and ROI on every flip. Step-by-step walkthrough for sports card flippers, sneaker resellers, and collectible traders."
        keywords="trackly demo, profit tracker walkthrough, flip calculator demo, reseller tool demo"
        canonical={`${SITE_URL}/demonstration`}
        ogTitle="Trackly Demo — See the Profit Tracker in Action"
        ogDescription="Step-by-step walkthrough of how Trackly calculates your real margins. Built for flippers who want clarity, not guesswork."
        jsonLd={demoJsonLd}
      />
      <Navbar />
      <main id="steps">
        <DemoHero />
        <DemoSteps />
        <DemoUseCases />
      </main>
      <Footer />
    </div>
  );
}
